import React from "react";
import './Feature.css';



const Feature = ({ feature }) => {

  return (

    <div className="feature-item">
      <div className="intro">
        <div className='icon'>{feature.icon}</div> {/* Feature icon */}
        <h3>{feature.title}</h3> {/* Feature title */}
      </div>
      <p>{feature.description}</p> {/* Feature description */}
    </div>
  );
};

export default Feature;